import { useRecurringUnRsvpModal } from "@/react/components/Modals/RecurringUnRsvpModal";
import { useLiveStreamsUsageLimits } from "@circle-react/components/LiveStreams/hooks";
import { usePunditUserContext } from "@circle-react/contexts";
import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { RecurringRsvpModal } from "../../Rsvp/RecurringRsvpModal";
import { useRecurringRsvpModal } from "../../Rsvp/RecurringRsvpModal/hooks/useRecurringRsvpModal";
import { RsvpAction } from "../../Rsvp/RsvpAction";
import { EVENT_TYPES, STATUS } from "../../helpers/constants";
import { isEventActive, isOnlineEvent } from "../shared/helpers";
import { JoinButton } from "./JoinButton";

export const RsvpActionButton = ({
  event,
  onChange,
  variant = "primary",
  isFullWidth = false,
}: any) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const {
    event_type: eventType,
    status,
    event_setting_attributes: eventData,
    rsvped_event: isEventConfirmed,
  } = event;
  const {
    hide_location_from_non_attendees: hideLocationFromNonAttendees,
    live_stream_room_setting_attributes: liveStreamRoomSetting,
  } = eventData || {};

  const { isRecurringRsvpOpen, openRecurringRsvpModal, onRecurringModalClose } =
    useRecurringRsvpModal({ event });
  const isSmallScreen = useSmOrMdScreenMediaQuery();
  const unRsvpModal = useRecurringUnRsvpModal();
  const { isMonthlyHourLimitReached, isStorageLimitReached } =
    useLiveStreamsUsageLimits();
  const isLiveLimitReached =
    isMonthlyHourLimitReached ||
    (liveStreamRoomSetting?.recording_enabled && isStorageLimitReached);

  const isRecurring = eventType === EVENT_TYPES.RECURRING;
  const isPublished = status === STATUS.PUBLISHED;
  const isJoinButtonVisibleToMember =
    !hideLocationFromNonAttendees || isEventConfirmed;
  const shouldDisplayJoinButton =
    isOnlineEvent(event) &&
    isEventActive(event) &&
    isJoinButtonVisibleToMember &&
    !isLiveLimitReached;

  const openRecurringUnRsvpModal = () => {
    void unRsvpModal.show({ event, onChange });
  };

  const getToggleRecurringRsvpFunction = () => {
    if (isViewOnlyMasquerading || !isRecurring) {
      return () => {};
    }
    return isEventConfirmed ? openRecurringUnRsvpModal : openRecurringRsvpModal;
  };

  const rsvpActionProps = {
    event,
    full: isFullWidth || isSmallScreen,
    variant,
    onChange,
    toggleRecurringRsvp: getToggleRecurringRsvpFunction(),
  };

  if (!isPublished) {
    return null;
  }

  if (shouldDisplayJoinButton) {
    return (
      <JoinButton
        event={event}
        full={isFullWidth || isSmallScreen}
        onChange={onChange}
      />
    );
  }

  return (
    <>
      <RsvpAction {...rsvpActionProps} />
      {isRecurring && (
        <RecurringRsvpModal
          event={event}
          show={isRecurringRsvpOpen}
          onClose={onRecurringModalClose}
          onChange={onChange}
        />
      )}
    </>
  );
};
